import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminHeaderComp from "../subComponent/AdminHeaderComp";
import DashboardBox from "../subComponent/DashboardBox";

const CreatorPortal = () => {
    const navigate = useNavigate();
    const [paymentclients, setpaymentclients] = useState(0);
    const [successPayments, setsuccessPayments] = useState(0);
    const [pendingPayments, setpendingPayments] = useState(0);

    useEffect(() => {
        if (!localStorage.getItem("invCreator")) {
            navigate("/login-creator");
        } else {
            handleDisplayClientDetails();
        }
    }, []);

    const handleDisplayClientDetails = async () => {
        // setIsAllLoading(true);
        try {
            const response = await fetch('https://apiroutetapxtream.invtechnologies.in/get_all_payment_services', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                const data = await response.json();
                // console.log(data.payment_status);
                const successCount = data.filter(item => item.payment_status === 'Successful').length;
                const pendingCount = data.filter(item => item.payment_status === 'Pending').length;

                setpaymentclients(data.length); // Total payment requests
                setsuccessPayments(successCount); // Successful payments
                setpendingPayments(pendingCount); // Pending payments
                // setRows(data.reverse());
            } else {
                throw new Error('Failed to get data');
            }
        } catch (err) {
            console.error('Error getting data:', err);
        } finally {
            // setIsAllLoading(false);
        }
    };

    return (
        <Box>
            <AdminHeaderComp />
            <Box sx={{
                width: "100vw",
                minHeight: "calc(100vh - 3.5rem)",
                display: "flex",
                justifyContent: "center",
                backgroundColor: "#0f172a",
            }}>
                <Box sx={{
                    width: "95%",
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: {xs:"space-evenly", md:"start"}, 
                    alignItems:{xs:"center", md:"start"},
                    gap: "1.5rem",
                    mt:"1rem"
                }}>
                    <DashboardBox title="Total Payment Requests" count={paymentclients} color="blue" />
                    <DashboardBox title="Successful Payments" count={successPayments} color="green" />
                    <DashboardBox title="Pending Payments" count={pendingPayments} color="red" />
                </Box>
            </Box>
        </Box>
    )
}
export default CreatorPortal;

